import { getTestGroupFromQueryOrStorage } from '../shared/getTestGroupFromQueryOrStorage';


export type MultiStepTestGroup = 'CONTROL' | 'VARIANT1' | 'VARIANT2';
export const validMultistepTestGroups: MultiStepTestGroup[] = [
  'CONTROL',
  'VARIANT1',
  'VARIANT2',
];

export const MULTISTEP_TEST_NAME = 'MultiStepEnterFlow_V6';

export const getMultistepTestGroup = (): MultiStepTestGroup => {

  // Try to get the test group from the query or localStorage
  const testGroupFromQueryOrStorage =
    getTestGroupFromQueryOrStorage<MultiStepTestGroup>(
      MULTISTEP_TEST_NAME,
      validMultistepTestGroups
    );

  if (testGroupFromQueryOrStorage) {
    return testGroupFromQueryOrStorage;
  }

  // Fallback to A/B test logic if no test group is found
  const testGroup = 'VARIANT1'

  return testGroup;
};
